import { get } from 'lodash'
import { required, email } from 'utils/validation'

const validate = values => {
  const errors = {
    newEmail:
      required(get(values, 'newEmail')) || email(get(values, 'newEmail')),
    newEmailAgain:
      required(get(values, 'newEmailAgain')) || email(get(values, 'newEmail')),
    newSecondaryEmail: email(get(values, 'newSecondaryEmail'))
  }

  if (get(values, 'newEmail') && get(values, 'newEmailAgain')) {
    if (get(values, 'newEmail') !== get(values, 'newEmailAgain')) {
      errors.newEmailAgain = {
        text: "Emails don't match",
        intlKey: 'errors.emails_dont_match',
        values: {}
      }
    }
  }

  return errors
}

export default validate
